import { render, staticRenderFns } from "./score-message.component.vue?vue&type=template&id=678d6f1a&scoped=true&"
import script from "./score-message.component.vue?vue&type=script&lang=ts&"
export * from "./score-message.component.vue?vue&type=script&lang=ts&"
import style0 from "./score-message.component.vue?vue&type=style&index=0&id=678d6f1a&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "678d6f1a",
  null
  
)

export default component.exports